import React from 'react';
import './debug.css';
import {observer} from 'mobx-react'

import {store} from '../../stores/store'

// components
import Indicators from './Indicators'
import Actions from './Actions'

import logo_aco from "../../images/logo_aco.png"
import IndicatorsPool from '../../js/IndicatorsPool';
import AepsPool from '../../js/AepsPool';
import { GAME_STATES } from '../../js/ids';
import { toJS } from 'mobx';

function Debug() {

  if(store.gameState === GAME_STATES.LOADING) return (
    <div id="game">
      Loading...
    </div>
  )

  // console.log("IndicatorsPool.all", toJS(IndicatorsPool.all ))

  return (
    <div className="debug">
      <header>
        <div><h1>SEGAE</h1><span>Serious Game in AgroEcology </span></div>
        <img className="logo" src={logo_aco} alt=""/>
      </header>

      <div className="main">
        <Indicators
          data={IndicatorsPool.all}
          values={IndicatorsPool.values} />

        <Actions
          data={AepsPool.categs}/>
      </div>

      <footer>
        <div className="yearNumber">Year <strong>#{store.yearNumber.toString()}</strong></div>
        <div className="nextYear">
          <button onClick={() => { store.goToNextYear() }}>Next year</button>
        </div>
      </footer>
    </div>
  );
}

export default observer(Debug);
